import { render } from "./NoteHeader.vue?vue&type=template&id=ee622636"
import script from "./NoteHeader.vue?vue&type=script&lang=js"
export * from "./NoteHeader.vue?vue&type=script&lang=js"

import "./NoteHeader.vue?vue&type=style&index=0&id=ee622636&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__